import { AttachmentValidationRules, RootAction } from "./types";

export interface State {
  data: AttachmentValidationRules | null;
}

const blankState = () => ({
  data: null
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "attachments/setValidationRules":
      return {
        ...state,
        data: action.rules
      };
  }
  return state;
};
